import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	Grid,
	TextField,
	MenuItem,InputLabel,Input,FormControl
} from "@mui/material";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { resetbankNameList, bankNameList } from "../../../redux/actions/bankNameListAction";
import { resetbankBranchList, bankBranchList } from "../../../redux/actions/bankBranchListAction";
import { resetbankDistrictList, bankDistrictList } from "../../../redux/actions/bankDistrictListAction";
import { resetbankMasterList, bankMasterList } from "../../../redux/actions/bankMasterListAction";
import AddNewUser from "./AddNewUser";
import NotificationPopups from "../../../NotificationPopup/NotificationPopups";
import { Card, Modal, ModalHeader, } from "reactstrap";
import { resetgetUserManagementList, getUserManagementList } from "../../../redux/actions/bankUserManagementListAction";


function UserManagementFilter() {
	const [name, setname] = useState("");
	const [username, setusername] = useState("");
	const [openModal, setopenModal] = useState(false);
	const [action, setaction] = useState("");

	const dispatch = useDispatch();
	const login = useSelector(({ login }) => login);
	const useraddupdate = useSelector(({ bankUserManagementAddUpdate }) => bankUserManagementAddUpdate);
	const deleteuser = useSelector(({ bankUserManagementDelete }) => bankUserManagementDelete);
	const blockuser = useSelector(({ bankUserManagementBlock }) => bankUserManagementBlock);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const openAddModal = (value) => {
		setaction(value)
		setopenModal(!openModal);
	}

	const userlistRequest = () => {

		const req = {
			actionCustomerMasterRequestVO: {
				id: "",
				role: "",
				userName: username,
				ratName: name,
				mobile: "",
				bankId: login.data.partnerId,
			}
		}

		console.log(req)

		if (regenerateTokenRes.success) {
			dispatch(getUserManagementList(req, regenerateTokenRes.data.AuthToken))
		}
	}

	const handleChange = ({ target: { value, name } }) => {

		if (name === "name") {
			setname(value);
		}

		if (name === "username") {
			setusername(value);
		}
	}

	useEffect(() => {
		if (useraddupdate.success) {
			userlistRequest();
			setopenModal(false);
			NotificationPopups(
				"success",
				"Success",
				useraddupdate.data.description
			);
		}
		if (useraddupdate.failed) {
			NotificationPopups(
				"error",
				"Failed",
				useraddupdate.data.description
			);
		}
		if (deleteuser.success || blockuser.success) {
			userlistRequest();
		}
	}, [useraddupdate, deleteuser, blockuser])

	useEffect(() => {
		return () => {
			dispatch(resetgetUserManagementList());
			// dispatch(resetbankBranchList());
			// dispatch(resetbankDistrictList());
			// dispatch(resetbankMasterList());
			// dispatch(resetbankMasterView());
		}
	}, [])

	return (
		<>
			<Card>
				<Grid
					container
					style={{
						padding: "10px",
						// marginTop: "1rem",
						marginLeft: "1rem",
						gap: "10px",
						textAlign: "right"
						// textAlign: "center"
					}}
				>
					<Grid item xs={12} md={8} sm={3} lg={8}></Grid>
					<Grid item xs={12} md={4} sm={3} lg={3}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={() => openAddModal("addUser")}
						>
							Add New User
						</CustomButton>
					</Grid>
				</Grid>
				<Grid
					container
					spacing={2}
					style={{
						padding: "25px",
						// marginTop: "2rem" 
					}}
				>
					<Grid item xs={12} sm={6} md={4} lg={4}>
						<FormControl required fullWidth>
							<InputLabel htmlFor="name">
								Name
							</InputLabel>
							<Input
								id="name"
								value={name}
								onChange={handleChange}
								name="name"
							/>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={6} md={4} lg={4}>
						<FormControl required fullWidth>
							<InputLabel htmlFor="username">
								Username
							</InputLabel>
							<Input
								id="username"
								value={username}
								onChange={handleChange}
								name="username"
							/>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={6} md={4} lg={3}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={userlistRequest}
						>
							Search <SearchIcon />
						</CustomButton>
					</Grid>
				</Grid>
			</Card>
			{openModal && <Modal
				isOpen={openModal}
				toggle={openAddModal}
				size="lg"            >
				<ModalHeader toggle={openAddModal}>User Details</ModalHeader>
				{/* <ModalBody className="password-modal-body"> */}
				<AddNewUser action={action} />
				{/* </ModalBody> */}
			</Modal>}
		</>
	)
}

export default UserManagementFilter